<page-load-header *ngIf="!initialized"></page-load-header>

<running-comparison-report [isShared]="true"></running-comparison-report>


